<template>
  <div class="footer clearfix" :class="langFlag ? 'enPage' : ''">
    <div class="ftInner clearfix">
      <div class="ft_lf1">
        <img src="~@/assets/image/svg/Bottom Logo_Black.svg" class="ft_logo" />
      </div>
      <div class="ft_lf2">
        <p class="ft_p1" @click="Torz(2)">
          {{ langFlag ? "JOURNAL" : "日志" }}
        </p>
        <p class="ft_p1" @click="Tosysj(0)">
          {{ langFlag ? "PROJECTS" : "作品案例" }}
        </p>
        <p class="ft_p1" @click="toAbout()">
          {{ langFlag ? "ABOUT" : "关于合恣" }}
        </p>
      </div>
      <div class="ft_lf3">
        <p class="ft_p2">{{ langFlag ? "Hezi Design" : "上海总部 " }}</p>
        <p class="ft_p3">{{ wzaddress }}</p>
        <p class="ft_p3">{{ wzybCode }}</p>
        <p class="ft_p4">{{ wztel }}</p>
        <p class="ft_p3">{{ wzemail }}</p>
      </div>
      <div class="ft_rg">
        <div class="ftcontct" @click="contactUs()">
          {{ langFlag ? "CONTACT" : "联系我们" }}
        </div>
        <div class="wxShare">
          <i class="share_ico2"></i>
          <div class="wx_se">
            <img src="~@/assets/images/footcode.jpg" class="footcode" />
          </div>
        </div>

        <!-- <i class="share_ico3"></i>
        <i class="share_ico4"></i> -->
      </div>
    </div>
    <!-- <div class="ftInner clearfix ywPage">
      <div class="ft_lf1">
        <img src="~@/assets/images/ft_logo.png"
             class="ft_logo" />
      </div>
      <div class="ft_lf2">
        <p class="ft_p1"
           @click="toAbout()">ABOUT</p>
        <p class="ft_p1"
           @click="Tosysj(0)">PROJECT</p>
        <p class="ft_p1"
           @click="Torz(2)">JOURNAL</p>
        <p class="ft_p1"
           @click="cotact(3)">CONTACT</p>
      </div>
      <div class="ft_lf3">
        <p class="ft_p2">Hezi Design</p>
        <p class="ft_p3">Room 301 North Building 6,No.353, Guiping Road, Xuhui District,</p>
        <p class="ft_p3">Shanghai, China, 200233</p>
        <p class="ft_p4">+86 19514619846</p>
        <p class="ft_p3">hello@hezi-design.com</p>
      </div>
      <div class="ft_rg">
        <i class="share_ico1"></i>
        <div class="wxShare">
          <i class="share_ico2"></i>
          <div class="wx_se">
            <img src="~@/assets/images/footcode.jpg"
                 class="footcode" />
          </div>
        </div>

        <i class="share_ico3"></i>
        <i class="share_ico4"></i>
      </div>
    </div> -->
    <p class="ft_de">Copyright © 2021 Hezi Design All Rights Reserved</p>
    <!-- 联系我们 -->
    <transition name="slide-fade">
      <contact v-show="contactFlag" @closeContact="closeContact"></contact>
    </transition>
  </div>
</template>

<script>
import contact from "@/components/contact.vue";
import { mapMutations, mapGetters, mapState } from "vuex";
export default {
  name: "foot",
  data() {
    return {
      ftInfo: [],
      wzname: "",
      wzaddress: "",
      wzemail: "",
      wztel: "",
      wzybCode: "",
      contactFlag: false,
      keywords: "",
      description: "",
      wztit: "",
    };
  },
  components: { contact },
  computed: {
    ...mapState(["langFlag", "lang", "title"]),
  },

  watch: {
    langFlag(val) {
      console.log("中英文的值", val);
      this.settings();
      document
        .querySelector('meta[name="keywords"]')
        .setAttribute("content", this.keywords);
      document
        .querySelector('meta[name="description"]')
        .setAttribute("content", this.description);
    },
  },
  mounted() {
    this.settings();
  },
  methods: {
    contactUs() {
      this.contactFlag = true;
    },
    closeContact() {
      this.contactFlag = false;
    },
    toAbout() {
      this.$router.push({
        name: "ab",
        // query: {
        //   type: type,
        // },
      });
    },
    Tosysj() {
      this.$router.push({
        name: "zp",
        // query: {
        //   type: type,
        // },
      });
    },
    Torz() {
      this.$router.push({
        name: "rz",
        // query: {
        //   type: type,
        // },
      });
    },

    // 获取网站配置
    settings() {
      let that = this;
      let type = "CN";
      if (this.langFlag) {
        //英文
        type = "EN";
      }
      let data = this.$post(
        "settings",
        that.$qs.stringify({
          type: type,
        })
      )
        .then((response) => {
          if (response.code == 1) {
            let info = response.data;
            response.data.forEach(function (item) {
              if (item.code == "WEB_PIC1") {
                //"首页位置1"
              } else if (item.code == "WEB_PIC2") {
                //"首页位置2"
              } else if (
                item.code == "WEB_TITLE" ||
                item.code == "WEB_TITLE_EN"
              ) {
                //网站标题"
                that.wzname = item.value;
                that.$store.commit("setTit", that.wzname);
              } else if (
                item.code == "WEB_ADDRESS" ||
                item.code == "WEB_ADDRESS_EN"
              ) {
                //联系地址
                that.wzaddress = item.value;
              } else if (
                item.code == "WEB_EMAIL" ||
                item.code == "WEB_EMAIL_EN"
              ) {
                //"电子邮件"
                that.wzemail = item.value;
              } else if (
                item.code == "WEB_PHONE" ||
                item.code == "WEB_PHONE_EN"
              ) {
                //联系电话"
                that.wztel = item.value;
              } else if (
                item.code == "WEB_CODE" ||
                item.code == "WEB_CODE_EN"
              ) {
                //邮编"
                that.wzybCode = item.value;
              } else if (
                item.code == "WEB_DESP" ||
                item.code == "WEB_DESP_EN"
              ) {
                //关键词
                that.keywords = item.value;
              } else if (
                item.code == "WEB_CONTENT" ||
                item.code == "WEB_CONTENT_EN"
              ) {
                //描述
                that.description = item.value;
              }
            });
            document
              .querySelector('meta[name="keywords"]')
              .setAttribute("content", this.keywords);
            document
              .querySelector('meta[name="description"]')
              .setAttribute("content", this.description);
            console.log("网站名称", that.wzname, that.title);
          }
        })
        .catch(function (error) {});
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/foot.vue